import React from "react";

export default function ObjectifActionModal({ open, title, onClose, children, footer }) {
    if (!open) return null;

    return (
        <div className="on-modal-backdrop" role="dialog" aria-modal="true">
            <div className="on-modal">
                <div className="on-modal__header">
                    <h3>{title}</h3>
                    <button className="on-modal__close" type="button" onClick={onClose} aria-label="Fermer">
                        ×
                    </button>
                </div>
                <div className="on-modal__body">{children}</div>
                {footer && <div className="on-modal__footer">{footer}</div>}
            </div>
        </div>
    );
}
